import { Component, Input, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../../shared";
import { SchoolService } from "../../../../../shared/services/school.service";
import { SysAdminService } from "../../../services/sysadmin.service";
import { UserAdminAddStaffComponent } from "./user-admin-add-staff/user-admin-add-staff.component";

@Component({
	selector: "caass-user-modify-details",
	templateUrl: "./user-modify-details.component.html",
	styleUrls: ["./user-modify-details.component.css"],
})
export class UserModifyDetailsComponent implements OnInit {
	constructor(
		private userService: UserService,
		private schoolService: SchoolService,
		private sysAdminService: SysAdminService,
		private dialogService: DialogService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();
		this.loadUserData();
	}

	ngOnChanges() {
		this.loadUserData();
	}

	//////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////

	EditInitLoad: any = false;
	NewInitLoad: any = false;

	@Input() EditMode: any = false;
	@Input() UserID: any = -1; //User Being Edited (if any)
	@Input() SchoolID: any = false; //From main page if adding

	user: any; //User Creating the new account
	@Input() Processing: any;

	Username: any = "";
	Password: any = "";
	ConfirmPassword: any = "";

	LoadingSchool: any = true;
	School: any;
	lstSchool: any = [];

	LoadingPerson: any = true;
	Person: any;
	lstStaff: any = [];
	NoStaff: any = false;

	ActiveOption: any = true;

	LoadingUserLevel: any = true;
	UserLevel: any;
	lstUserLevels: any;

	LoadingDetails: any = false;
	UserDetails: any;

	LoadingPrefs: any = false;
	PasswordMinLength: any = 0;
	PasswordMinNumbers: any = 0;
	PasswordMinSpecialChars: any = 0;

	PasswordInstructions: string = "";
	LoadingInstructions: boolean = false;

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////////////

	loadUserData() {
		// console.log("Edit Mode");
		// console.log(this.EditMode);

		// console.log("User ID");
		// console.log(this.UserID);

		this.loadPasswordInstructions();

		if (this.EditMode == true) {
			if (this.UserID > 0 && this.EditInitLoad == false) {
				this.EditInitLoad = true;
				this.loadUserDetailsData();
			}
		} else {
			if (this.NewInitLoad == false) {
				this.NewInitLoad = true;
				this.loadPasswordPrefs();
				this.loadSchool();
				this.loadUserLevel();
			}
		}
	}

	loadUserDetailsData() {
		this.LoadingDetails = true;

		var result = this.sysAdminService.SysAdminUserDetailsSelect(this.UserID);
		result.subscribe(
			(response) => {
				this.UserDetails = response[0];

				this.Username = this.UserDetails.UserName;
				this.Password = this.UserDetails.Password;
				this.ConfirmPassword = this.UserDetails.Password;

				if (this.UserDetails.PersonActive == false) {
					this.ActiveOption = false;
				}

				this.LoadingDetails = false;

				this.loadPasswordPrefs();
				this.loadSchool();
				this.loadUserLevel();
			},
			(error) => {
				this.LoadingDetails = false;
			}
		);
	}

	loadPasswordPrefs() {
		this.LoadingPrefs = true;

		var result = this.sysAdminService.GetPasswordPreferences();
		result.subscribe(
			(response) => {
				var lstPrefs: any = response;

				for (var i = 0; i < lstPrefs.length; i++) {
					var next = lstPrefs[i];

					if (next.KeyName == "PasswordLength") {
						this.PasswordMinLength = next.KeyValue;
					} else if (next.KeyName == "PasswordNumbers") {
						this.PasswordMinNumbers = next.KeyValue;
					} else if (next.KeyName == "PasswordSpecialChars") {
						this.PasswordMinSpecialChars = next.KeyValue;
					}
				}

				this.LoadingPrefs = false;
			},
			(error) => {
				this.LoadingPrefs = false;
			}
		);
	}

	loadPasswordInstructions() {
		this.LoadingInstructions = true;

		var result = this.sysAdminService.PasswordInstructionSelect();
		result.subscribe(
			(response: any) => {
				this.PasswordInstructions = response.str;

				this.LoadingInstructions = false;
			},
			(error) => {
				this.LoadingInstructions = false;
			}
		);
	}

	loadSchool() {
		this.LoadingSchool = true;

		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				this.School = this.lstSchool[0];

				if (this.UserDetails != undefined) {
					for (var z = 0; z < this.lstSchool.length; z++) {
						var next = this.lstSchool[z];

						if (next.SchoolID == this.UserDetails.SchoolID) {
							this.School = next;
							break;
						}
					}
				} else {
					for (var z = 0; z < this.lstSchool.length; z++) {
						var next = this.lstSchool[z];

						if (next.SchoolID == this.SchoolID) {
							this.School = next;
							break;
						}
					}
				}

				this.LoadingSchool = false;

				this.loadStaff(-1);
			},
			(error) => {
				this.LoadingSchool = false;
			}
		);
	}

	loadStaff(val) {
		this.LoadingPerson = true;

		this.NoStaff = false;
		this.lstStaff = [];

		var result = this.sysAdminService.SysAdminStaffSelectList(this.School.SchoolID, this.ActiveOption == true ? 1 : 0, this.UserID);
		result.subscribe(
			(response) => {
				this.lstStaff = response;

				if (this.lstStaff.length > 0) {
					this.Person = this.lstStaff[0];
				} else {
					this.Person = null;
					this.NoStaff = true;
				}

				if (this.UserDetails != undefined) {
					for (var z = 0; z < this.lstStaff.length; z++) {
						var next = this.lstStaff[z];

						if (next.PersonID == this.UserDetails.PersonID) {
							this.Person = next;
							break;
						}
					}
				}
				if (val > 0) {
					for (var z = 0; z < this.lstStaff.length; z++) {
						var next = this.lstStaff[z];

						if (next.PersonID == val) {
							this.Person = next;
						}
					}
				}

				this.LoadingPerson = false;
			},
			(error) => {
				this.NoStaff = true;
				this.LoadingPerson = false;
			}
		);
	}

	loadUserLevel() {
		this.LoadingUserLevel = true;

		var result = this.sysAdminService.UserLevelGetList();
		result.subscribe(
			(response) => {
				this.lstUserLevels = response;

				//
				// School users can't create district users
				//
				// School, 3
				// District, 1
				//

				this.lstUserLevels = this.lstUserLevels.filter((level) => level.UserLevelID >= this.user.UserLevelID);

				this.UserLevel = this.lstUserLevels[0];

				if (this.UserDetails != undefined) {
					for (var z = 0; z < this.lstUserLevels.length; z++) {
						var next = this.lstUserLevels[z];

						if (next.UserLevelID == this.UserDetails.UserLevelID) {
							this.UserLevel = next;
							break;
						}
					}
				}

				this.LoadingUserLevel = false;
			},
			(error) => {
				this.LoadingUserLevel = false;
			}
		);
	}

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////

	onAddStaff() {
		var ref = this.dialogService.open(UserAdminAddStaffComponent, {
			header: "Add Staff",
			width: "fit-content",
			data: {
				SchoolID: this.School.SchoolID,
			},
		});
		ref.onClose.subscribe((response: any) => {
			if (response > 0) {
				this.loadStaff(response);
			}
		});
	}

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////////////

	onSchoolChange(val) {
		this.School = val;

		//Load Data
		this.loadStaff(-1);
	}

	onActiveChange(val) {
		this.ActiveOption = val;

		//Load Data
		this.loadStaff(-1);
	}

	onShow() {
		var Buttons = <HTMLElement>document.getElementById("MainButtons");

		Buttons.style.marginBottom = "100px";
	}

	onHide() {
		var Buttons = <HTMLElement>document.getElementById("MainButtons");

		Buttons.style.marginBottom = "0px";
	}

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////////

	IsLoading() {
		return (
			this.LoadingDetails == true ||
			this.LoadingPrefs == true ||
			this.LoadingSchool == true ||
			this.LoadingPerson == true ||
			this.LoadingUserLevel == true ||
			this.LoadingInstructions == true
		);
	}

	CanChangeStaff() {
		return true;
		//return this.EditMode == false || this.user.userID == 0; // 10.14 let SU change Staff Member
	}

	//////////////////////////////////////////////////////////////////
}
